import React from "react";
import { AppBar, Dialog, Slide, Toolbar } from "@mui/material";
import CustomMuiDataTable from "src/Components/CustomMuiDataTable";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PaymentsDialog = ({
  paymentsVisible,
  handleClosePaymentsModal,
  paymentsData,
  paymentsColumns,
  paymentsOptions
}) => {
  return (
    <Dialog
      fullScreen
      open={paymentsVisible}
      onClose={handleClosePaymentsModal}
      TransitionComponent={Transition}
      style={{ zIndex: 2235 }}
    >
      <AppBar className="position-relative">
        <Toolbar>
          <button
            type="button"
            className="close-modal-button"
            onClick={handleClosePaymentsModal}
          >
            &times;
          </button>
          <h4 className="text-white mx-3 my-0">Payments</h4>
        </Toolbar>
      </AppBar>
      <div style={{ padding: "25px" }}>
        <CustomMuiDataTable
          title={"Payments"}
          data={paymentsData}
          columns={paymentsColumns}
          options={paymentsOptions}
        />
      </div>
    </Dialog>
  );
};

export default PaymentsDialog; 